import { createAction } from 'redux-act';

// Self Attendance action
const selfAttendanceRequest = createAction('SELF_ATTENDANCE_REQUEST', data => data);
const selfAttendanceSuccess = createAction('SELF_ATTENDANCE_SUCCESS', data => data);
const selfAttendanceError = createAction('SELF_ATTENDANCE_ERROR');

// My Team Attendance action
const myTeamAttendanceRequest = createAction('MY_TEAM_ATTENDANCE_REQUEST', data => data);
const myTeamAttendanceSuccess = createAction('MY_TEAM_ATTENDANCE_SUCCESS', data => data);
const myTeamAttendanceError = createAction('MY_TEAM_ATTENDANCE_ERROR');

// All Team Attendance
const allTeamAttendanceRequest = createAction('ALL_TEAM_ATTENDANCE_REQUEST', data => data);
const allTeamAttendanceSuccess = createAction('ALL_TEAM_ATTENDANCE_SUCCESS', data => data);
const allTeamAttendanceError = createAction('ALL_TEAM_ATTENDANCE_ERROR');

// Attendance Report
const attendanceReportRequest = createAction('ATTENDANCE_REPORT_REQUEST', data => data);
const attendanceReportSuccess = createAction('ATTENDANCE_REPORT_SUCCESS', data => data);
const attendanceReportError = createAction('ATTENDANCE_REPORT_ERROR');

// Attendance Report
const getDepartmentWiseAttendanceRequest = createAction('GET_DEPARTMENT_WISE_ATTENDANCE_REQUEST', data => data);
const getDepartmentWiseAttendanceSuccess = createAction('GET_DEPARTMENT_WISE_ATTENDANCE_SUCCESS', data => data);
const getDepartmentWiseAttendanceError = createAction('GET_DEPARTMENT_WISE_ATTENDANCE_ERROR');

const getAllEmployeeAttendanceRequest = createAction('GET_ALL_EMPLOYEE_ATTENDANCE_REQUEST', data => data);
const getAllEmployeeAttendanceSuccess = createAction('GET_ALL_EMPLOYEE_ATTENDANCE_SUCCESS', data => data);
const getAllEmployeeAttendanceError = createAction('GET_ALL_EMPLOYEE_ATTENDANCE_ERROR');

// All Team Attendance action
const handleClearOtherAttendanceStore = createAction('HANDLE_CLEAR_OTHER_ATTENDANCE_STORE', data => data);

export default {
    selfAttendanceRequest,
    selfAttendanceSuccess,
    selfAttendanceError,

    myTeamAttendanceRequest,
    myTeamAttendanceSuccess,
    myTeamAttendanceError,

    allTeamAttendanceRequest,
    allTeamAttendanceSuccess,
    allTeamAttendanceError,

    attendanceReportRequest,
    attendanceReportSuccess,
    attendanceReportError,

    getDepartmentWiseAttendanceRequest,
    getDepartmentWiseAttendanceSuccess,
    getDepartmentWiseAttendanceError,

    getAllEmployeeAttendanceRequest,
    getAllEmployeeAttendanceSuccess,
    getAllEmployeeAttendanceError,
    

    handleClearOtherAttendanceStore,
}